import { render, staticRenderFns } from "./Autobonus.vue?vue&type=template&id=d6a280ae&"
import script from "./Autobonus.vue?vue&type=script&lang=js&"
export * from "./Autobonus.vue?vue&type=script&lang=js&"
import style0 from "./Autobonus.vue?vue&type=style&index=0&id=d6a280ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports